import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Links } from 'components/Links';

export const LinkPage: FC = () => {
	return (
		<Page title="Links – EAS Control Center">
			<Links />
		</Page>
	);
};
